// @flow
import React from 'react';
import Center from 'app/common/react/ui/experimental/Center';
import PulsarNewAnimation from 'app/common/react/ui/experimental/PulsarNewAnimation';
import { Experiment } from 'app/common/react/components/experiments';
import { Pulsar as GestaltPulsar, Touchable } from 'gestalt';

const GESTALT_PULSAR_SIZE = 136;

type PulsarProps = {|
  anchor: ?HTMLElement,
  onTouch: (event: SyntheticEvent<>) => void,
  paused?: boolean,
|};
export function Pulsar(props: PulsarProps) {
  const { anchor, onTouch, paused } = props;

  return (
    <Center
      anchor={anchor}
      subjectHeightOverride={GESTALT_PULSAR_SIZE}
      subjectWidthOverride={GESTALT_PULSAR_SIZE}
    >
      <Touchable onTouch={({ event }) => onTouch(event)} shape="circle" fullWidth={false}>
        <Experiment name="web_nux_new_gestalt_pulsar_animation">
          {({ anyEnabled }) =>
            anyEnabled ? <PulsarNewAnimation paused={paused} /> : <GestaltPulsar paused={paused} />
          }
        </Experiment>
      </Touchable>
    </Center>
  );
}

export default Pulsar;
